import thumbnail_GT from '../../../assets/GT.png';
import thumbnail_iX from '../../../assets/iX.png';
import thumbnail_GTL from '../../../assets/GTL.png';
import thumbnail_GM from '../../../assets/GM.png';
import thumbnail_GM120 from '../../../assets/GM-120.png';
import thumbnail_iM from '../../../assets/iM.png';
import thumbnail_iM120 from '../../../assets/iM-120.png';
import thumbnail_OS from '../../../assets/OS.png';
import thumbnail_FX from '../../../assets/FX.png';
import thumbnail_LN150 from '../../../assets/LN-150.png';
import thumbnail_LN160 from '../../../assets/LN-160.png';
import thumbnail_LN100 from '../../../assets/LN-100.png';
import thumbnail_LN50 from '../../../assets/LN-50.png';
import thumbnail_LN1000i from '../../../assets/LN-1000i.png';
import thumbnail_ESN from '../../../assets/ESN.png';
import thumbnail_GTS from '../../../assets/GTS-M1.png';
import thumbnail_SET from '../../../assets/SET-M1.png';
import { Skeleton } from '@mui/material';
import { MODEL } from '../../../constant/instrument';

export function Thumbnail(props: { model: string }) {
  function makeThumbnail(src: any) {
    return <img style={{ width: 100 }} src={src} alt='thumbnail' />;
  }

  if (props.model === MODEL.GT) {
    return makeThumbnail(thumbnail_GT);
  } else if (props.model === MODEL.iX) {
    return makeThumbnail(thumbnail_iX);
  } else if (props.model.startsWith('GTL')) {
    return makeThumbnail(thumbnail_GTL);
  } else if (props.model === MODEL.GM120) {
    return makeThumbnail(thumbnail_GM120);
  } else if (props.model.startsWith('GM')) {
    return makeThumbnail(thumbnail_GM);
  } else if (props.model === MODEL.iM120) {
    return makeThumbnail(thumbnail_iM120);
  } else if (props.model.startsWith('iM')) {
    return makeThumbnail(thumbnail_iM);
  } else if (props.model.startsWith('OS')) {
    return makeThumbnail(thumbnail_OS);
  } else if (props.model.startsWith('FX')) {
    return makeThumbnail(thumbnail_FX);
  } else if (props.model === MODEL.LN150) {
    return makeThumbnail(thumbnail_LN150);
  } else if (props.model === MODEL.LN160) {
    return makeThumbnail(thumbnail_LN160);
  } else if (props.model === MODEL.LN100) {
    return makeThumbnail(thumbnail_LN100);
  } else if (props.model === MODEL.LN50) {
    return makeThumbnail(thumbnail_LN50);
  } else if (props.model === MODEL.LN1000i) {
    return makeThumbnail(thumbnail_LN1000i);
  } else if (props.model === MODEL.ESN100) {
    return makeThumbnail(thumbnail_ESN);
  } else if (props.model === MODEL.GTSM1) {
    return makeThumbnail(thumbnail_GTS);
  } else if (props.model === MODEL.SETM1) {
    return makeThumbnail(thumbnail_SET);
  } else {
    return <Skeleton sx={{ width: 100, height: 100 }} />;
  }
}
